import { Checkbox } from '@/components/ui/checkbox';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import type { Control } from 'react-hook-form';

interface CheckboxInputProps {
    field: {
        handle: string;
        label?: string;
        instructions?: string;
    };
    control: Control<Record<string, unknown>>;
}

export default function CheckboxInput({ field, control }: CheckboxInputProps) {
    return (
        <FormField
            control={control}
            name={field.handle}
            render={({ field: formField }) => (
                <FormItem className="flex flex-row items-start space-x-3 space-y-0">
                    <FormControl>
                        <Checkbox
                            checked={formField.value as boolean}
                            onCheckedChange={formField.onChange}
                        />
                    </FormControl>
                    <div className="space-y-1 leading-none">
                        <FormLabel>{field.label}</FormLabel>
                        {field.instructions && (
                            <p className="text-muted-foreground text-sm">{field.instructions}</p>
                        )}
                    </div>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
